import React from 'react';
import { Button } from 'tuui';
import { IndicationContent, INDICATION_TYPES, RefreshIcon } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from '../reviewEvents.module.scss';

export const GeneralErrorModal = ({ onRetry }) => {
    return (
        <>
            <div className={styles['container']}>
                <div className={styles['title']}>
                    <FormattedMessage id="codeless.review.event.header" defaultMessage="Review Changes" />
                </div>
            </div>
            <div className={styles['error-indication']}>
                <IndicationContent
                    type={INDICATION_TYPES.ERROR}
                    contentClassName={styles['error-indication-message']}
                    displayIcon
                >
                    <FormattedMessage
                        id="codeless.save.and.close.error"
                        defaultMessage="Sorry, an error occurred while saving the event. Please try again. If the problem persists, please contact support."
                    />
                </IndicationContent>
            </div>
            <div className={styles['error-actions']}>
                <Button onClick={onRetry} className={styles['error-retry-button']} size={Button.size.md}>
                    <RefreshIcon className={styles['retry-icon']} />
                    <FormattedMessage id="codeless.retry.button" defaultMessage="Try Again" />
                </Button>
            </div>
        </>
    );
};
